<template>
  <b-modal id="modal-request" ref="modal" size="lg" title="Request" @show="setData" @hidden="resetModal"
           @ok="handleOk">
    <b-form @submit.stop.prevent="onSubmit" >
      <div class="row">
        <!-- grid column -->
        <div class="col-lg-12">
          <!-- .card -->
          <div class="card card-fluid">
            <!-- .card-body -->
            <div class="card-body">
              <legend><em class="fa fa-user"></em> To be filled by user</legend>
              <div class="form-row">
                <label class="col-md-3">Date of Request</label>
                <div class="col-md-6 mb-3">
                  <flat-pickr :config="config" v-model="input_data.date"></flat-pickr>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Requester Name</label>
                <div class="col-md-6 mb-3">
                  {{input_data.requestor_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Status of the request</label>
                <div class="col-md-6 mb-3">
                  <v-select :options="option_status_request" v-model="input_data.request_type" :reduce="data=>data.id" label="name"></v-select>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Project allocation</label>
                <div class="col-md-6 mb-3">
                  <v-select :options="option_project" v-model="input_data.project" :reduce="data=>data.id" label="name"></v-select>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Province assignment</label>
                <div class="col-md-6 mb-3">
                  <v-select :options="option_province" v-model="input_data.state" :reduce="data=>data.id" label="name"></v-select>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Duty station</label>
                <div class="col-md-6 mb-3">
                  <v-select :options="option_duty_station" v-model="input_data.duty_station" :reduce="data=>data.id" label="name"></v-select>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Department</label>
                <div class="col-md-6 mb-3">
                  <v-select :options="option_department" v-model="input_data.department" :reduce="data=>data.id" label="name"></v-select>
                </div>
              </div>
              <legend><em class="fa fa-calendar"></em> Duration of contract</legend>
              <div class="form-row">
                <label class="col-md-3">Duration start</label>
                <div class="col-md-6 mb-3">
                  <flat-pickr :config="config" v-model="input_data.duration_start"></flat-pickr>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Duration end</label>
                <div class="col-md-6 mb-3">
                  <flat-pickr :config="config" v-model="input_data.duration_end"></flat-pickr>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Remarks</label>
                <div class="col-md-6 mb-3">
                  <b-form-textarea rows="3" v-model="input_data.remarks" ></b-form-textarea>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Equipment request</label>
                <div class="col-md-6 mb-3">
                  <b-form-textarea rows="3" v-model="input_data.equipment_request" ></b-form-textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-form>
    <template v-slot:modal-footer>
      <div class="w-100">
        <button class="btn btn-secondary float-right" @click="resetModal"> Cancel </button>
        <button class="btn btn-warning float-right mr-1" @click="input_data.stat_id=1;handleOk($event)"> Submit </button>
        <button class="btn btn-primary float-right mr-1" @click="input_data.stat_id=0; handleOk($event)"> Save as Draft </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
import flatPickr from "vue-flatpickr-component"
import vSelect from "vue-select"
import {BForm, BFormInput, BFormTextarea, BModal} from "bootstrap-vue"
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";

export default {
  name: "StaffInput",
  components:{
    Breadcrumb,
    flatPickr,
    vSelect,
    BForm,
    BFormInput,
    BFormTextarea,
    BModal,
  },
  props:{
    data:{
      type:Object
    }
  },
  data(){
    return{
      input_data:{
        date:"",
        requestor_name:"",
        request_type:"",
        project:"",
        state:"",
        duty_station:"",
        department:"",
        duration_start:"",
        duration_end:"",
        remarks:"",
        equipment_request:"",
        stat_id:0
      },
      detail_country_setting:{},
      country_code:'',
      config:{
        altFormat: 'M j, Y',
        altInput: true,
        dateFormat: 'Y-m-d',
        locale: {
          rangeSeparator: ' - '
        },
      },
      option_project:[],
      option_status_request:[],
      option_province:[],
      option_duty_station:[],
      option_department:[],
    }
  },
  watch:{
    detail_country_setting(){
      this.getState()
    }
  },
  methods:{
    handleOk(evt){
      evt.preventDefault()
      this.onSubmit()
    },
    resetModal(){
      this.$parent.data = null
      this.input_data = {
        date:"",
        requestor_name:"",
        request_type:"",
        project:"",
        state:"",
        duty_station:"",
        department:"",
        duration_start:"",
        duration_end:"",
        remarks:"",
        equipment_request:"",
        stat_id:0
      }
      this.$refs.modal.hide()
    },
    onSubmit(){
      let userProfile = this.$store.getters.userProfile.data.attributes
      let payload = {
        emp_id:this.$store.getters.empId,
        user_id:this.$store.getters.userId,
        emp_name:userProfile.emp_name,
        req_type:this.input_data.request_type,
        date:this.input_data.date,
        project:this.input_data.project,
        state:this.input_data.state,
        unit:this.input_data.duty_station,
        section:this.input_data.department,
        reason:this.input_data.remarks,
        equipment:this.input_data.equipment_request,
        duration_start:this.input_data.duration_start,
        duration_end:this.input_data.duration_end,
        stat_id:this.input_data.stat_id
      }

      if(this.data !== null){
        payload.id = this.data.id
        AxiosCall.Put(payload, urlApi.staff.update).then(res=>{
          if(res.success){
            this.$parent.getData()
            this.$parent.successMessage(res.message)
            this.$refs.modal.hide()
          }else{
            this.$parent.errorMessage(res.message)
          }
        }).catch(e=>{
          this.$parent.errorMessage(e.response.data.message)
        })
      }else{
        AxiosCall.Post(payload, urlApi.staff.add).then(res=>{
          if(res.success){
            this.$parent.getData()
            this.$parent.successMessage(res.message)
            this.$refs.modal.hide()
          }else{
            this.$parent.errorMessage(res.message)
          }
        }).catch(e=>{
          this.$parent.errorMessage(e.response.data.message)
        })
      }
    },
    setData(){
      let userProfile = this.$store.getters.userProfile.data.attributes
      this.input_data.requestor_name = userProfile.emp_name
      this.getRequestTypeStaff()
      this.getProject()
      this.getSettingValue()
      this.getDutyStation()
      this.getDepartment()
      setTimeout(()=>{
        if(this.data !== null){
          this.getDetail()
        }
      }, 100)
    },
    onBack(){
      this.$router.push({path:"/staff"})
    },
    getRequestTypeStaff(){
      let payload = {}
      AxiosCall.Get(payload, urlApi.reference.staff_request_type).then(res=>{
        if(res.success){
          this.option_status_request = res.atributes
        }else{
          this.$parent.errorMessage(res.message)
        }
      }).catch(e=>{
        this.$parent.errorMessage(e.response.data.message)
      })
    },
    getProject(){
      let userProfile = this.$store.getters.userProfile
      let payload = {
        company_id :userProfile.data.attributes.company_id
      }
      AxiosCall.Get(payload, urlApi.project.projectAll).then(res=>{
        if(res.success){
          this.option_project = res.atributes
        }else{
          this.$parent.errorMessage(res.message)
        }
      }).catch(e=>{
        this.$parent.errorMessage(e.response.data.message)
      })
    },
    getSettingValue(){
      let payload = {
        setting_name:"default_country_code"
      }
      AxiosCall.Get(payload, urlApi.reference.setting_value).then(res=>{
        if(res.success){
          this.country_code = res.atributes[0].value

          this.getDetailCountry()
        }else{
          this.$parent.errorMessage(res.message)
        }
      }).catch(e=>{
        console.log(JSON.stringify(e))
        this.$parent.errorMessage(e.response.data.message)
      })
    },
    getDetailCountry(){
      let payload = {
        code :this.country_code
      }
      AxiosCall.Get(payload, urlApi.country.detail).then(res=>{
        if(res.success){
          this.detail_country_setting = res.atributes
        }else{
          this.$parent.errorMessage(res.message)
        }
      }).catch(e=>{
        this.$parent.errorMessage(e.response.data.message)
      })
    },
    getState(){
      let payload = {
        country_id : this.detail_country_setting[0].id
      }
      AxiosCall.Get(payload, urlApi.state.combo).then(res=>{
        if(res.success){
          this.option_province = res.atributes
        }else {
          this.$parent.errorMessage(res.message)
        }
      }).catch(e=>{
        console.log(JSON.stringify(e))
        this.$parent.errorMessage(e.response.data.message)
      })
    },
    getDutyStation(){
      let userProfile = this.$store.getters.userProfile
      let payload = {
        company_id :userProfile.data.attributes.company_id
      }
      AxiosCall.Get(payload, urlApi.reference.unit).then(res=>{
        if(res.success){
          this.option_duty_station = res.atributes
        }else{
          this.$parent.errorMessage(res.message)
        }
      }).catch(e=>{
        this.$parent.errorMessage(e.response.data.message)
      })
    },
    getDepartment(){
      let userProfile = this.$store.getters.userProfile
      let payload = {
        company_id :userProfile.data.attributes.company_id
      }
      AxiosCall.Get(payload, urlApi.reference.department).then(res=>{
        if(res.success){
          this.option_department = res.atributes
        }else{
          this.$parent.errorMessage(res.message)
        }
      }).catch(e=>{
        this.$parent.errorMessage(e.response.data.message)
      })
    },
    getDetail(){
      let payload = {
        id:this.data.id
      }
      AxiosCall.Get(payload, urlApi.staff.detail).then(res=>{
        if(res.success){
          let data = res.atributes
          this.input_data={
            date: data.date_request,
            requestor_name: data.emp_name,
            request_type: data.staff_req_type_val,
            project: data.project_id,
            state: data.state_id,
            duty_station: data.unit_id,
            department: data.section_id,
            duration_start: data.duration_start,
            duration_end: data.duration_end,
            remarks: data.reason,
            equipment_request: data.equipment,
          }
        }else {
          this.$parent.errorMessage(res.message)
        }
      }).catch(e=>{
        this.$parent.errorMessage(e.response.data.message)
      })
    }
  },
  created() {
  }
}
</script>